export const SITE_TITLE: string = "Posix Project";
export const HOST: string = import.meta.env.VITE_APP_HOST;
